<template>
  <div class="menu">
    <div
      class="men_box"
      :class="$route.path.includes(item.path) ? 'active' : ''"
      v-for="(item, index) in routerData"
      :key="index"
      @click="handleOpen(item, item.path, index)"
    >
      <el-icon class="iceoc"><icon-menu /></el-icon>
      <span class="menu_text">{{ getSliceName(item.name) }}</span>
    </div>
  </div>
</template>

<script setup>
import { Document, Menu as IconMenu, Location, Setting } from "@element-plus/icons-vue";
import {
  ref,
  reactive,
  defineExpose,
  defineEmits,
  onMounted,
  watch,
  nextTick,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "@/stores/modules/router.js";
const userData = useStore();
const { getAcitve } = userData;

const router = useRouter();
const route = useRoute();
const emit = defineEmits(["childer"]);

import routers from "@/router";
const state = reactive({
  isCollapse: false,
});

watch(
  () => route.path,
  (newPath) => {
    router.options.routes[0].children.map((v, index) => {});
  },
  { immediate: false }
);

onMounted(() => {
  try {
    if (route.path == "/home") {
      return;
    }
  } catch {}
});

const handleOpen = (key, keyPath, index) => {
  router.push(keyPath);
  emit("childer", key);
  state.isActive = index;
  getAcitve(index);
};

// 截取导航文字前两个
const getSliceName = (val) => {
  return val.slice(0, 4);
};
// 是否收起左边菜单
const toggleCollapse = () => (state.isCollapse = !state.isCollapse);

// 暴露子组件的方法
defineExpose({
  toggleCollapse,
});

let routerData = [];
routerData = routers.options.routes[0].children;
</script>

<style scoped>
.menu {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: #0b0f16;
  box-sizing: border-box;
}

.men_box {
  color: #94a3b8;
  width: 100%;
  padding: 15px 24px;
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-left: 3px solid transparent;
  box-sizing: border-box;
}

.men_box:hover {
  background-color: rgba(255, 255, 255, 0.05);
  color: #fff;
}

.active {
  background: linear-gradient(90deg, rgba(0, 255, 136, 0.1) 0%, rgba(0, 255, 136, 0.01) 100%) !important;
  /* color: #00ff88 !important; */
  border-left: 3px solid #00ff88 !important;
  font-weight: 600;
}

.menu_text {
  margin-left: 12px;
  letter-spacing: 0.5px;
}

.iceoc {
  font-size: 16px;
  margin-top: 1px;
}

::-webkit-scrollbar {
  width: 2px;
  height: 2px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: transparent;
}
</style>
